import React, { useState, useRef, useCallback ,useEffect} from "react";
import ReactDOM from "react-dom";
import moment from "moment"; 
import { Calendar } from "antd";
 
 
  const ScheduleCalendar = (prop) => {
  

  const [viewData, setViewData] = useState([]);
  const [ employeeId,setEmployeeId] = useState([]);
  
  const [close, setClose] = useState(false);

  useEffect(() => {
    //console.log(prop.update);

    if (prop.scheduledata) {
      //console.log("prop",prop);
      var temppath=prop.scheduledata ;
      setViewData([...temppath] );   
      
     
    }
  }, [prop.coordinate]);
  
   
 
  
  function getMonthData(value) {
    if (value.month() === 8) {
      return 1394;
    }
  }

function monthCellRender(value) {
  const num = getMonthData(value);
  //console.log("monthCellRender")


  return num ? (
    <div className="notes-month">
      <section>{num}</section>
      <span>Backlog number</span>
    </div>
  ) : null;
}


const openDetails = (discountApprovalId) => {
  //console.log(discountApprovalId);
  //  deleteDiscount(
  //    {
  //      url: `/api/fieldActivityWeb/?${discountApprovalId}`,
  //      method: "DELETE",
  //    },
  //    (res) => {
  //      //console.log(res);
  //      toast.success("Discount Deleted ");
       

  //    },
    
  //  );
 };

 

  function dateCellRender(value) {

    var _month = (value.month()+1)<10? "0"+(value.month()+1) :(value.month()+1)
    var _date = (value.date())<10? "0"+(value.date()) :(value.date())
    
     var sdate=_date  +"/"+_month+"/"+value.year()
    //console.log('sdate',sdate)
    //console.log("Datacell",viewData)
    const listData = viewData.filter((item)=> item.startDate.toString()==sdate)

    //console.log('listData',listData)

    return (

       <div>
        {listData.map(item => (

          
                          

          <div>
            <a href="#" onClick={openDetails}
           className={  item.endDate&&item.endDate !=""?                  
             "taskCompleted"   
            :   item.actualStartDate&&item.actualStartDate !=""? "taskInprogrss"    
            :"taskPending"} 
            >{item.fieldActivityName}</a>
            </div>
))}  
       </div>
      
    );
  }
  function onPanelChange(value) {
    //console.log("onPanelChange",value.month())
    // var date = new Date();
    // var firstDay = new Date(value.year(), value.month()+1 ,1);
    // var lastDay = new Date(value.year(), value.month() + 2, 0);
    // //console.log("firstDay",firstDay)
    // //console.log("lastDay",lastDay)
  
  }


  
  return (
  


    <div className="App">
         <Calendar
    dateCellRender={dateCellRender} monthCellRender={monthCellRender}
  // monthCellRender={monthCellRender}
   onPanelChange={onPanelChange}
  // onSelect={onSelect}
/>
    </div>
  );
}

export default ScheduleCalendar;
